<template>
  <div>
    <!-- 查询栏 -->
    <div class="query-nav">
      <el-form ref="queryFormRef" :model="queryForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item prop="value" label="字典值">
              <el-input v-model.trim="queryForm.value" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="code" label="唯一编码">
              <el-input v-model.trim="queryForm.code" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" style="margin-right: 6px;" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" style="float: right;" @click="handleAddData">点击新增</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <div class="table">
      <el-table :data="dictDataList" v-loading="tableLoading" stripe border>
        <el-table-column type="index" label="序号" width="60" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="value" label="字典值" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="code" label="唯一编码" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="sort" label="排序" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="remark" label="备注" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="status" label="状态" align="center" :resizable="false">
          <template slot-scope="{ row }">
            <span>{{row.status === 0 ? '正常' : '冻结'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{ row }">
            <el-tooltip class="item" effect="dark" content="编辑字典值" placement="top">
              <i
                class="iconfont iconcaozuo-1xiugai_1"
                style="margin-right: 16px;"
                @click="handleEditData(row)"
              ></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="top">
              <i class="iconfont iconcaozuo-2shanchu_1" @click="confirmDelete(row)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页区域 -->
    <div class="page">
      <el-pagination
        :total="total"
        :current-page="queryForm.pageNo"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 20, 30, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>

    <!-- 新增/编辑字典值 -->
    <el-dialog
      :append-to-body="true"
      :title="dictDialogTitle"
      :visible.sync="dictDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="700px"
      @closed="cancelSubmit"
    >
      <el-form ref="paramsFormRef" :rules="paramsFormRules" :model="paramsForm" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="value" label="字典值">
              <el-input v-model.trim="paramsForm.value" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="code" label="唯一编码">
              <el-input v-model.trim="paramsForm.code" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="sort" label="排序">
              <el-input v-model.number="paramsForm.sort" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="remark" label="备注">
              <el-input v-model.trim="paramsForm.remark" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSubmit">取消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="comfirmSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dictApi from 'api/home/dictionary.js';

export default {
  props: {
    // 字典类型id 用于查询该类型下的字典值
    typeId: {
      default: '',
      required: true
    }
  },
  data() {
    return {
      total: 0,
      queryForm: {
        value: '',
        code: '',
        pageSize: 10,
        pageNo: 1
      },
      tableLoading: true,
      dictDataList: [],
      dictDialogTitle: '新增字典值',
      dictDialogVisible: false,
      paramsForm: {
        id: '',
        value: '',
        code: '',
        sort: null,
        remark: ''
      },
      paramsFormRules: {
        value: [{ required: true, message: '请输入字典值', trigger: 'blur' }],
        code: [{ required: true, message: '请输入唯一编码', trigger: 'blur' }],
        sort: [{ required: true, type: 'number', message: '请输入数字', trigger: 'blur' }]
      },
      btnLoading: false
    };
  },
  created() {},
  methods: {
    // 获取字典值列表
    getDictDataList(id) {
      this.tableLoading = true;
      const params = this.queryForm;
      params.typeId = id;
      dictApi
        .getDictDataList(params)
        .then(res => {
          if (res.data.code === 200) {
            this.total = res.data.data.totalRows;
            this.dictDataList = res.data.data.rows;
          }
          // else {
          //   this.$message.error(res.data.message);
          //   this.tableLoading = false;
          // }
          this.tableLoading = false;
        })
        .catch(err => {
          this.tableLoading = false;
        });
    },
    // 添加字典值
    addDictData() {
      const params = this.paramsForm;
      params.typeId = this.typeId;

      dictApi.postNewDictData(params).then(res => {
        if (res.data.code === 200) {
          this.btnLoading = false;
          this.dictDialogVisible = false;
          this.$message({
            message: '添加字典值成功',
            type: 'success'
          });
          this.handleReset();
        }
        this.btnLoading = false;
        //  else if (res.data.code === 2012002) {
        //   this.btnLoading = false;
        //   this.$message({
        //     message: '唯一编码重复，请重新输入',
        //     type: 'error'
        //   });
        // }
      });
    },
    // 编辑字典值
    editDictData() {
      const params = this.paramsForm;
      params.typeId = this.typeId;

      dictApi.postEditDictData(params).then(res => {
        if (res.data.code === 200) {
          this.dictDialogVisible = false;
          this.$message({
            message: '修改字典值成功',
            type: 'success'
          });
          this.getDictDataList(this.typeId);
        }
        this.btnLoading = false;
        // else if (res.data.code === 2012002) {
        //   this.btnLoading = false;
        //   this.$message({
        //     message: '唯一编码重复，请重新输入',
        //     type: 'error'
        //   });
        // }
      });
    },
    // 搜索
    handleSearch() {
      this.queryForm.pageNo = 1;
      this.getDictDataList(this.typeId);
    },
    // 重置
    handleReset() {
      this.$refs.queryFormRef.resetFields();
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = 10;
      this.getDictDataList(this.typeId);
    },
    // 分页
    handleSizeChange(val) {
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = val;
      this.getDictDataList(this.typeId);
    },
    handleCurrentChange(val) {
      this.queryForm.pageNo = val;
      this.getDictDataList(this.typeId);
    },
    // 重置表格
    resetParamsForm() {
      this.paramsForm.id = '';
      this.paramsForm.value = '';
      this.paramsForm.code = '';
      this.paramsForm.sort = null;
      this.paramsForm.remark = '';
    },
    // 点击新增字典值
    handleAddData() {
      this.dictDialogTitle = '新增字典值';
      this.dictDialogVisible = true;
    },
    // 点击编辑字典值
    handleEditData(row) {
      this.paramsForm.id = row.id;
      this.paramsForm.value = row.value;
      this.paramsForm.code = row.code;
      this.paramsForm.sort = row.sort;
      this.paramsForm.remark = row.remark;
      this.dictDialogTitle = '编辑字典值';
      this.dictDialogVisible = true;
    },
    // 取消新增/编辑字典值
    cancelSubmit() {
      this.dictDialogVisible = false;
      this.$refs.paramsFormRef.resetFields();
      this.resetParamsForm();
    },
    // 确认新增/编辑字典值
    comfirmSubmit() {
      this.btnLoading = true;
      this.$refs.paramsFormRef.validate(valid => {
        if (!valid) {
          this.btnLoading = false;
          return;
        }
        // 无 id 为新增， 有 id 为编辑
        if (!this.paramsForm.id) {
          this.addDictData();
        } else {
          this.editDictData();
        }
      });
    },
    // 删除字典值
    confirmDelete(row) {
      this.$confirm(`待删除字典值名称 —— “${row.value}”`, `确定删除此条字典值？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          dictApi
            .postDeleteDictData({
              id: row.id
            })
            .then(res => {
              if (res.data.code === 200) {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.handleReset();
              }
              // else {
              //   this.$message.error(res.data.message);
              // }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消删除'
          });
        });
    }
  },
  watch: {
    typeId: {
      handler: function (newVal) {
        this.queryForm = {
          value: '',
          code: '',
          pageSize: 10,
          pageNo: 1
        };
        this.dictDataList = [];
        this.getDictDataList(newVal);
        return newVal;
      },
      immediate: true
    }
  }
};
</script>

<style lang="less" scoped>
.page {
  margin: 16px 0;
  overflow: hidden;

  .el-pagination {
    float: right;
  }
}

.iconfont {
  font-size: 28px;
  color: #409dff;
  cursor: pointer;
}
</style>
